
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.542 11.625h-5.167v-7.75h-7.75v7.75H6.458l9.042 9.042 9.042-9.042zM6.458 23.25v2.583h18.084V23.25H6.458z","fill":"#0064FF"}})])
          )
        }
      }
    